var $ = require('jquery');

var $delayTime = 1000;

$(window).on('load', function(){
    var $loadingAnim = $('#loadingAnim'),
    $body = $('body');

    setTimeout( function(){
        
        $body.addClass('loaded');
        //$loadingAnim.remove();
        $loadingAnim.find('.loadingAnim_line').on('transitionend', function( e ){ 
            $(this).parent().remove(); });
    }, $delayTime );
});

var $header = $('#header');

// Nav Toggle Button
$('#toggle').on('click', function(){
    $header.toggleClass('is-open');
});

$('a[href^="#"]').on('click', function() {
    // スクロールの速度
    var speed = 400; // ミリ秒
    // アンカーの値取得
    var href= $(this).attr("href");
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を数値で取得
    var position = target.offset().top;
    // スムーススクロール
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
});

/*const mediaQuery = window.matchMedia('(max-width: 1024px)');
 
// ページが読み込まれた時に実行
handle(mediaQuery);
 
// ウィンドウサイズを変更しても実行（ブレイクポイントの監視）
mediaQuery.addListener(handle);
 
function handle(mm) {
  if (mm.matches) {
    $('.header__innerNavListSingle > div').on('click', function(){
        //クリックされた.accordion_oneの中の.accordion_headerに隣接する.accordion_innerが開いたり閉じたりする。
        $(this).next('ul').slideToggle();
        $(this).toggleClass("is-open");
    });
  }
}*/